import { type JSX, useState } from 'react';

import { ArtificialIntelligenceApi } from 'Api/ArtificialIntelligence/ArtificialIntelligenceApi';
import { DocumentApi } from 'Api/Document/DocumentApi';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { Breadcrumb, BreadcrumbLink, BreadcrumbText } from 'Components/Nav/Breadcrumb/Breadcrumb';
import { PageLayoutDefault } from 'Components/PageLayout/PageLayoutDefault';
import { LinkButtonToast, TextToast } from 'Components/Toast/Toast';
import { GOVERNANCE } from 'Config/Paths';
import { AI_TAB_KEY } from 'Pages/Governance/GovernanceLibrary/GovernanceLibrary';

import { AiDocGeneratorCreateForm } from './AiDocGeneratorCreateForm';

export interface AiDocGeneratorCreateProps {
    artificialIntelligenceApi: ArtificialIntelligenceApi;
    documentApi: DocumentApi;
}

export const AiDocGeneratorCreate = (props: AiDocGeneratorCreateProps): JSX.Element => {
    const { regulations } = useCachedData();
    const [failureMessage, setFailureMessage] = useState<string>();
    const [successMessage, setSuccessMessage] = useState<string>();

    return (
        <>
            {failureMessage && <TextToast clearToast={() => setFailureMessage(undefined)} text={failureMessage} variant="failure" />}
            {successMessage && <LinkButtonToast variant="success" clearToast={() => setSuccessMessage(undefined)} linkButtonText={'Return to Governance Integration'} linkButtonTo={`/${GOVERNANCE}#${AI_TAB_KEY}`} text={successMessage} />}
            <PageLayoutDefault
                headerBreadcrumb={
                    <Breadcrumb textColor="blue">
                        <BreadcrumbLink link={`/${GOVERNANCE}#${AI_TAB_KEY}`}>Governance Integration</BreadcrumbLink>
                        <BreadcrumbText>SummIT Guide™ Document Generator</BreadcrumbText>
                    </Breadcrumb>
                }
                headerTitle="SummIT Guide™ Document Generator"
                headerDescription="Submitting this form will generate a new governance document using SummIT Guide™. SummIT Guide™ will utilize the information you provide to tailor the document it creates to your organization's specific needs. The process will take several minutes, and once complete the new document will appear in the table on the previous page."
                body={[
                    {
                        content: <AiDocGeneratorCreateForm artificialIntelligenceApi={props.artificialIntelligenceApi} regulations={regulations} documentApi={props.documentApi} setFailureMessage={setFailureMessage} setSuccessMessage={setSuccessMessage} />,
                    },
                ]}
            />
        </>
    );
};
